module.exports = __webpack_public_path__ + "img/img_e_brand_up_color_halo_png.ec17610b.png";